import { FlowStepData } from "./FlowStepData";
import { FlowExecutionData } from "../Engine/FlowExecutionData";
import { IUserInfo } from "../../Plugins/DataStorage/IUserInfo";
import { ExecutionData } from "../../Common/Data/ExecutionData/ExecutionData";
import { FlowStepTestContext } from "../Structure/FlowTestingContext";

export abstract class BaseFlowStepRunner {
    get type() {
        return this.getFlowStepData().__type!;
    }

    abstract getFlowStepData(): FlowStepData;

    abstract start(
        user: IUserInfo,
        thread: string,
        executionData: ExecutionData,
        flowExecutionData: FlowExecutionData,
        testContext?: FlowStepTestContext
    ): Promise<void>;
}
